export default __webpack_public_path__ + "static/media/cat.19fd2c02.ogg";